import React from "react";
import OpportunityActivity from "./timeline/OpportunityActivity";
import ScheduledEventsActivity from "./timeline/ScheduledEventsActivity";
import "react-vertical-timeline-component/style.min.css";

interface ActivityProps {
  opportunity_id: string;
  showScheduledEventsActivity?: boolean;
}

const Activity: React.FC<ActivityProps> = ({ opportunity_id, showScheduledEventsActivity }) => {
  if (showScheduledEventsActivity) {
    return <ScheduledEventsActivity schedule_id={opportunity_id} />;
  }

  return <OpportunityActivity opportunity_id={opportunity_id} />;
};

export default Activity;
